
<mat-form-field class="pe-se-input">
  <mat-label>Background Color</mat-label>
  <input matInput
         [(ngModel)]="item.data.bgColor"
         [(colorPicker)]="item.data.bgColor"
         [style.background]="item.data.bgColor"
         cpPosition="bottom"  >
</mat-form-field>

<mat-form-field class="pe-se-input">
  <mat-label>Text Color</mat-label>
  <input matInput
         [(ngModel)]="item.data.textColor"
         [(colorPicker)]="item.data.textColor"
         [style.background]="item.data.textColor"
         cpPosition="bottom">
</mat-form-field>


<div class="pe-se-title-input">
  <i class="fa fa-arrows-h" aria-hidden="true"></i> Component Width
</div>
<mat-button-toggle-group class="btn-toggle" [(ngModel)]="item.data.fullWidth" name="FullWidth"
                         aria-label="Full Width">
  <mat-button-toggle [value]="false">Contained</mat-button-toggle>
  <mat-button-toggle [value]="true">Full Width</mat-button-toggle>
</mat-button-toggle-group>
<div class="pe-se-title-input">
  <i class="fa fa-align-center" aria-hidden="true"></i> Align
</div>
<mat-button-toggle-group class="btn-toggle" [(ngModel)]="item.data.align" name="FullWidth"
                         aria-label="Full Width">
  <mat-button-toggle value="LEFT">Left</mat-button-toggle>
  <mat-button-toggle value="CENTER">Center</mat-button-toggle>
  <mat-button-toggle value="RIGHT">Right</mat-button-toggle>
</mat-button-toggle-group>

<div class="pe-se-title-input mg-b">
  <i class="fa fa-arrows-alt" aria-hidden="true"></i> Spacing
</div>
<app-spacing-setting
  [spacing]="item.data.spacing"></app-spacing-setting>
<mat-form-field class="pe-se-input">
  <mat-label>Color Border</mat-label>
  <input matInput
         [(ngModel)]="item.data.borderStyle.color"
         [(colorPicker)]="item.data.borderStyle.color"
         [style.background]="item.data.borderStyle.color"
         cpPosition="bottom">
</mat-form-field>
<mat-form-field class="pe-se-input">
  <mat-label>Style Border</mat-label>
  <mat-select [(ngModel)]="item.data.borderStyle.style">
    <mat-option *ngFor="let style of cs.listOfBorderStyle()" [value]="style" >
      {{style}}
    </mat-option>
  </mat-select>
</mat-form-field>
<div class="pe-se-title-input mg">
  <i class="fa fa-picture-o" aria-hidden="true"></i> Background Image
</div>
<div class='pe-se-input pe-se-file'>
  <span class="fa fa-times pe-se-remove" (click)="item.data.bgImage = ''"></span>
  <input type='file' (change)="selectFileToBg($event)" accept="image/*">
  <img alt="background Image" [attr.src]="imageSelector(item.data.bgImage)"/>
</div>
